const MINUTE_MS = 60 * 1000;
const DAY_MS = 24 * 60 * MINUTE_MS;

// Meta rejects a schedule that starts in the past, so keep a small lead time.
const START_LEAD_MS = 5 * MINUTE_MS;

function toLocalInputValue(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function clampToMin(input: HTMLInputElement | null): void {
  if (!input || !input.value || !input.min) return;
  if (!input.validity.rangeUnderflow) return;

  input.value = input.min;
}

export function syncScheduleWindow(startSelector: string, endSelector: string): void {
  const startInput = document.querySelector<HTMLInputElement>(startSelector);
  const endInput = document.querySelector<HTMLInputElement>(endSelector);
  const earliestStart = new Date(Date.now() + START_LEAD_MS);

  if (startInput) {
    startInput.min = toLocalInputValue(earliestStart);
    clampToMin(startInput);
  }
  if (!endInput) return;

  const start = startInput?.value ? new Date(startInput.value) : earliestStart;
  if (Number.isNaN(start.getTime())) return;

  endInput.min = toLocalInputValue(new Date(start.getTime() + DAY_MS));
  clampToMin(endInput);
}

export function bindScheduleWindow(namespace: string, startSelector: string, endSelector: string): void {
  // Both ends are bound: the end field needs clamping in its own right, not
  // just when a new start pushes its floor forward.
  $(document)
    .off(`change.${namespace}`)
    .on(`change.${namespace}`, `${startSelector}, ${endSelector}`, () =>
      syncScheduleWindow(startSelector, endSelector));
  syncScheduleWindow(startSelector, endSelector);
}
